import { styled } from '@mui/material/styles';

import { rem, Theme } from '../../theme';

export const StyledWrapper = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        max-width: ${theme.tggSpacing(rem(62.8), 251)};
        padding: ${theme.tggSpacing([0, rem(3)], [0, 7.5])};
        margin: ${theme.tggSpacing([rem(3), 'auto', rem(4), 'auto'], [7.5, 'auto', 10, 'auto'])};

        ${theme.breakpoints.up('desktop')} {
            padding: ${theme.tggSpacing(0, 0)};
        }
	`}
`;
